import { h } from '@stencil/core';
import { send, virtualPageRelatedProductsEvent, isAnalyticsEnabled } from '@pes-ui/utils';
import { getMyProductsFromConnector } from '../../pes-my-products-connector/utils';
export class RelatedProducts {
  constructor() {
    this.onRelatedProductHandler = (group, index) => {
      this.openModalIndex = index;
      if (isAnalyticsEnabled()) {
        send(virtualPageRelatedProductsEvent, { relatedSectionId: group.groupId });
      }
    };
    this.items = undefined;
    this.columnsCount = undefined;
    this.cartTransferEnabled = undefined;
    this.openModalIndex = undefined;
    this.productId = undefined;
    this.localeCode = undefined;
    this._localeCode = undefined;
    this.apcCta = undefined;
    this.isAPCSite = undefined;
    this.apcCtaUrl = undefined;
    this.productAvailabilityInfo = undefined;
    this.isExternalConsumer = undefined;
    this.productRelationCustomConfig = undefined;
    this.ctaInfo = undefined;
    this.myProducts = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  dialogCloseHandler() {
    this.openModalIndex = undefined;
  }
  componentDidLoad() {
    getMyProductsFromConnector().then((res) => (this.myProducts = res));
  }
  render() {
    var _a, _b, _c, _d;
    return (h("div", { class: "related-products" }, h("div", { class: "related-products__body" }, h("div", { class: "related-products__list" }, (_b = (_a = this.items) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, (group, index) => {
      const firstProduct = group.products[0];
      return (h("pes-related-products-group-card", { class: {
          'related-products__group': true,
          [`related-products__group--columns-count-${this.columnsCount}`]: true,
        }, onClick: () => this.onRelatedProductHandler(group, index), name: group.viewProductLabel, imageUrl: firstProduct.product.thumbnailImageLink.url, productsCount: group.products.length, key: group.groupId }));
    }))), (_d = (_c = this.items) === null || _c === void 0 ? void 0 : _c.map) === null || _d === void 0 ? void 0 :
      _d.call(_c, (group, index) => (h("pes-related-products-dialog", { isOpen: this.openModalIndex === index, products: group.products, header: group.popupLabel, cartTransferEnabled: this.cartTransferEnabled, myProducts: this.myProducts, groupId: group.groupId, productId: this.productId, key: group.groupId, localeCode: this.localeCode, productAvailabilityInfo: this.productAvailabilityInfo, apcCta: this.apcCta, isExternalConsumer: this.isExternalConsumer, productRelationCustomConfig: this.productRelationCustomConfig, ctaInfo: this.ctaInfo })))));
  }
  static get is() { return "pes-related-products"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["related-products.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["related-products.css"]
    };
  }
  static get properties() {
    return {
      "items": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "RelatedProductGroup[]",
          "resolved": "RelatedProductGroup[]",
          "references": {
            "RelatedProductGroup": {
              "location": "import",
              "path": "../../../generated/graphql"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Object with component title, product categories and products data"
        }
      },
      "columnsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Number of columns of cards in desktop version"
        },
        "attribute": "columns-count",
        "reflect": false
      },
      "cartTransferEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines which CTA button should be shown: \"Add to Cart\" or \"Add to My Products/Remove from My Products\".\n Used only if there are no CTA settings given by a consumer."
        },
        "attribute": "cart-transfer-enabled",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "_localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-locale-code",
        "reflect": false
      },
      "apcCta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TApcCta",
          "resolved": "{ urls: { apcHost: string; }; labels: { addToCartButtonLabel: string; vatLabel: string; inStockLabel: string; authToAddToFavorites: string; removeFromFavorites: string; addToFavorites: string; favorites: string; itemAddedTo: string; signIn: string; createAccount: string; itemRemovedFrom: string; failedResponse: string; }; }",
          "references": {
            "TApcCta": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isAPCSite": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-a-p-c-site",
        "reflect": false
      },
      "apcCtaUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "apc-cta-url",
        "reflect": false
      },
      "productAvailabilityInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isExternalConsumer": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines consumer is external-user"
        },
        "attribute": "is-external-consumer",
        "reflect": false
      },
      "productRelationCustomConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRelatedProductCustomConfig",
          "resolved": "{ showBothProductCtasButton?: boolean; productCtasButtonConfig?: { addToFavoritesLabel?: string; removeFromFavoritesLabel?: string; }; showQuantityColumn?: boolean; quantityColumnConfig?: { label?: string; valueKey?: string; }; }",
          "references": {
            "TRelatedProductCustomConfig": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ctaInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.TCtaInfo",
          "resolved": "{ [key: string]: { type: string; label?: string; primary?: boolean; url?: string; gaAttributes?: TGaAttributes; }; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "openModalIndex": {},
      "myProducts": {}
    };
  }
  static get events() {
    return [{
        "method": "onLoadPrices",
        "name": "onLoadPrices",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TProductAvailabilityInfo",
          "resolved": "{ howToBuyShowing: { [productId: string]: boolean; }; addToFavoritesInfo: TAddToFavoritesInfo; prices: TPrices; substitution: TSubstitution; factoryStore: TFactoryStore; availability: TAvailability; }",
          "references": {
            "TProductAvailabilityInfo": {
              "location": "import",
              "path": "../../../globals/apc-cta/types"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "backdrop",
        "method": "dialogCloseHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "didCloseDialog",
        "method": "dialogCloseHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
